import React, { useEffect, useState } from 'react';
import Icon from '../../Icon';
import Input from '../../Inputs/Input';
import { translate } from '../../../Services/translation';

interface MyPagesRmaRowQuantityInputProps {
  value: number;
  maxValue: number;
  onChange: (quantity: number) => void;
}

const MyPagesRmaRowQuantityInput = ({
  value,
  maxValue,
  onChange,
}: MyPagesRmaRowQuantityInputProps) => {
  const [quantity, setQuantity] = useState(value);

  useEffect(() => {
    setQuantity(value);
  }, [value]);

  useEffect(() => {
    if (quantity > maxValue) {
      setQuantity(maxValue);
      onChange(maxValue);
    } else if (quantity <= 0 && maxValue > 1) {
      setQuantity(1);
      onChange(1);
    }
  }, [maxValue, onChange, quantity]);

  return (
    <div className="mx-auto flex flex-row items-center">
      <Icon
        name="minus"
        role="button"
        className="w-8"
        onClick={() => onChange(quantity - 1)}
      />
      <Input
        title={translate('mypage.rma.quantity-to-return')}
        wrapperClassName="w-14"
        inputSize="small"
        type="number"
        className="text-center"
        min={1}
        value={quantity}
        onChange={(e) => setQuantity(e.target.valueAsNumber)}
        onBlur={(e) => onChange(e.target.valueAsNumber)}
      />
      <Icon
        name="plus"
        role="button"
        className="w-8"
        onClick={() => onChange(quantity + 1)}
      />
    </div>
  );
};

export default MyPagesRmaRowQuantityInput;
